export const getWhatsAppUrl = (message = '') => {
  const phone = process.env.REACT_APP_PHONE || '+2349033782254';
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${phone.replace('+', '')}?text=${encodedMessage}`;
};

export const getEmailUrl = (subject = '') => {
  const email = process.env.REACT_APP_EMAIL || 'info@programmoceuticals.com';
  const encodedSubject = encodeURIComponent(subject);
  return `mailto:${email}?subject=${encodedSubject}`;
};

export const getPhoneUrl = () => {
  const phone = process.env.REACT_APP_PHONE || '+2349033782254';
  return `tel:${phone}`;
};